import { type ReactNode } from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import classNames from 'classnames';

import Card from './Card';

const useStyles = makeStyles({
  parentTitle: {
    display: 'flex',
  },
  title: { marginLeft: '15px', marginBottom: '14px' },
  tooltip: { margin: '16px 0 0 5px' },
});

type CardWrapperProps = {
  children: ReactNode;
  title?: string;
  additionalContentAfterTitle?: ReactNode;
  tooltip?: ReactNode;
  classesOverride?: {
    parentTitle?: string;
  };
};

const CardWrapper = ({
  children,
  title,
  additionalContentAfterTitle,
  tooltip = null,
  classesOverride,
}: CardWrapperProps) => {
  const classes = useStyles();

  return (
    <Card>
      <div
        className={classNames(
          classes.parentTitle,
          classesOverride?.parentTitle
        )}
      >
        {title && <h3 className={classes.title}>{title}</h3>}
        {tooltip && <span className={classes.tooltip}>{tooltip}</span>}
        {additionalContentAfterTitle}
      </div>
      {children}
    </Card>
  );
};

export default CardWrapper;
